import { Component } from '@angular/core';
import { DataserviceService } from '../dataservice.service';
import { AppComponent } from '../app.component';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NzNotificationService } from 'ng-zorro-antd/notification';

@Component({
  selector: 'app-groups',
  templateUrl: './groups.component.html',
  styleUrls: ['./groups.component.css']
})
export class GroupsComponent {

  addModal = false;
  searchValue = '';
  users: any;
  spinner: boolean = false;
  groups: any;
  groupsList: any;
  currentUser: any;
  companies = [];
  selectedCompany: any;
  groupForm: FormGroup
  showCompanyDD: boolean = false;

  constructor(private dataService: DataserviceService,
              private nzNotify: NzNotificationService,
              private app: AppComponent) {

                this.groupForm = new FormGroup({
                  id: new FormControl(null),
                  name: new FormControl(null, [Validators.required]),
                  company: new FormControl(null, [Validators.required]),
                  users: new FormControl([])  // Initialize as empty array
                })
              }

  ngOnInit(){
    this.currentUser = JSON.parse(localStorage.getItem('user') || '{}');

    this.selectedCompany = this.currentUser?.company_id;

    if(this.hasPermission('view_all_groups')) {
      this.spinner = true;
      this.getCompanies();
      this.showCompanyDD = true;
    }else if(this.hasPermission('view_distributor_groups')) {
      this.getDistributorCompanies();
      this.showCompanyDD = true;
    }else {
      this.getAssociatedCompanyInfo();
    }

  }

  getAssociatedCompanyInfo() {
    console.log('im in the getAssociatedCompanyInfo');
    this.dataService.getData(`groups/companyGroups/${this.selectedCompany}`)
      .subscribe({
        next: (res: any) => {
          console.log('res here - ', res);
          this.groups = res?.groups;
          this.groupsList = res?.groups;
          this.users = res?.users;
          this.spinner = false;
        },
        error: (err: any) => {
          this.spinner = false;
          this.errorNotification('Failed to getAssociatedCompanyInfo')
        }
      })
  }


getCompanies() {
    this.dataService.getData(`company`)
    .subscribe({
      next: (res: any) => {
        this.companies = res.data;
        this.getAssociatedCompanyInfo();
      },
      error: (err: any) => {
        this.errorNotification('Failed to get companies')
      }
    })
}

getDistributorCompanies() {
  this.dataService.getData(`company/companies-by-distributor/${this.currentUser?.distributor_id}`)
  .subscribe({
    next: (res: any) => {
      this.companies = res?.data;
      this.getAssociatedCompanyInfo();
    },
    error: (err: any) => {
      console.log('error on get companies by distributor: ', err)
      this.errorNotification('Failed to get companies by distributor')
    }
  });
}


  hasPermission(permission: string): boolean {
    return this.app.hasPermission(permission)
  }

  private ensureUsersLoaded(companyId: string): Promise<void> {
    return new Promise((resolve) => {
      if (Array.isArray(this.users) && this.users.length > 0 && this.selectedCompany === companyId) {
        resolve();
        return;
      }
      this.dataService.getData(`groups/companyGroups/${companyId}`).subscribe({
        next: (res: any) => { this.users = res?.users || []; this.selectedCompany = companyId; resolve(); },
        error: () => { this.users = []; resolve(); }
      });
    });
  }

  showModal(g: any) {
    console.log('Opening modal for group:', g);
    
    this.groupForm.reset();
    this.addModal = true;

    if (!g) {
      this.groupForm.patchValue({ 
        company: this.selectedCompany,
        users: []
      });
      return;
    }

    // Load group details including members
    this.dataService.getData(`groups/detail/${g.id}`).subscribe({
      next: (res: any) => {
        console.log('Got group detail:', res);

        // Set available users
        this.users = res.companyUsers || [];
        this.selectedCompany = res.group?.owner_id;

        // Get the member IDs from the response
        const memberIds = res.memberIds || [];

        // Log some debug info
        console.log('Available users sample:', this.users.slice(0, 2).map((u: any) => ({
          id: u.id,
          name: `${u.first_name} ${u.last_name}`
        })));
        console.log('Member IDs to select:', memberIds);

        // Verify the member IDs exist in the users array
        const missingUsers = memberIds.filter((id: any) => 
          !this.users.find((u: any) => u.id === id)
        );
        if (missingUsers.length) {
          console.warn('Some member IDs not found in users array:', missingUsers);
        }

        // First set the basic form values
        this.groupForm.patchValue({
          id: g.id,
          name: g.name,
          company: g.owner_id
        });

        // Then set the users array separately
        this.groupForm.get('users')?.setValue(memberIds);
        console.log('Form users value after patch:', this.groupForm.get('users')?.value);
        console.log('Available options sample:', this.users.slice(0, 2));
      },
      error: (err) => {
        console.error('Failed to load group detail:', err);
        this.users = [];
        this.groupForm.patchValue({
          id: g.id,
          name: g.name,
          company: g.owner_id,
          users: []
        });
      }
    });
  }

  saveModal() {
    if(this.groupForm.valid) {
      if(this.groupForm.get('id')?.value) {
        this.updateGroup();
      }else {
        this.addGroup();
      }
    }else{
      this.nzNotify.create(
        'warning',
        'Warning!',
        `Please fill out the required fields`,
        { nzPlacement: 'top' }
      );
    }
  }

  showAddModal(){
    this.addModal = true;
  }

  addGroup(){
    let obj = {
      name: this.groupForm.get('name')?.value,
      users: this.groupForm.get('users')?.value,
      owner_id: this.groupForm.get('company')?.value
    }

    this.dataService.postData(obj, 'groups/create')
      .subscribe({
        next: (res: any) => {
          this.successNotification('created')
          this.getAssociatedCompanyInfo();
          this.groupForm.reset()
        },
        error: (err: any) => {
          this.spinner = false;
          this.errorNotification('Failed to addGroup')
        }
      })
  }

  cancelModal(){
    this.addModal = false;
    this.groupForm.reset();
  }

  search(){
    this.groupsList = this.groups.filter((item: any) => item.name.toLowerCase().indexOf(this.searchValue.toLowerCase()) !== -1);
  }

  updateGroup(){
    let obj = {
      id: this.groupForm.get('id')?.value,
      name: this.groupForm.get('name')?.value,
      owner_id: this.groupForm.get('company')?.value,
      users: this.groupForm.get('users')?.value,
    }

    this.dataService.postData(obj, 'groups/update')
      .subscribe({
        next: (r:any) => {
          this.successNotification('updated')
          this.getAssociatedCompanyInfo();
          this.addModal = false;
          this.groupForm.reset()
      },
      error: (err: any) => {
        this.errorNotification('Failed to updateGroup')
      }
    })
  }

  successNotification(str: string) {
    this.nzNotify.create(
      'success',
      'Success!',
      `Group was ${str} successfully!`,
      { nzPlacement: 'top' }
    );
  }

  errorNotification(str: string) {
    this.nzNotify.create(
      'error',
      'Error!',
      str,
      { nzPlacement: 'top' }
    );
  }

}
